import { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const ReviewProcessSettingsHeader: FC = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { reviewId } = useParams()

  return (
    <ResourceHeader
      title={i18n.t('performance_process.reviews.edit')}
      primaryAction={{
        label: i18n.t('performance_process.reviews.go_to_overview_button'),
        onClick: () =>
          navigate(
            navigation.performanceProcess.reviews.review.fullPath({ reviewId: Number(reviewId) })
          ),
      }}
    />
  )
}
